import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { PROJECTS } from '../../constants';
import ProjectTile from './ProjectTile';

const MOBILE_TOP_ROW_COUNT = Math.floor(PROJECTS.length / 2);
const MOBILE_COLUMN_ANGLE = 0.49;

const ProjectsCarousel = ({ isPhone, isActive }) => {
  const [activeId, setActiveId] = useState(null);

  const onClick = useCallback((index) => {
    if (!isPhone || !isActive) return;
    setActiveId((currentId) => (currentId === index ? null : index));
  }, [isActive, isPhone]);

  useEffect(() => {
    if (!isActive) setActiveId(null);
  }, [isActive]);

  const tiles = useMemo(() => {
    const fov = Math.PI;
    const distance = 13;
    const count = PROJECTS.length;

    return PROJECTS.map((project, i) => {
      let angle;
      let tileDistance;
      let y;
      let scale;

      if (isPhone) {
        const isTopRow = i < MOBILE_TOP_ROW_COUNT;
        const rowIndex = isTopRow ? i : i - MOBILE_TOP_ROW_COUNT;
        const rowCount = isTopRow
          ? MOBILE_TOP_ROW_COUNT
          : count - MOBILE_TOP_ROW_COUNT;

        // Stagger the short row over the gaps in the longer row. At this
        // spacing the phone cards have a visible gutter instead of colliding.
        angle = Math.PI / 2
          + (rowIndex - (rowCount - 1) / 2) * MOBILE_COLUMN_ANGLE;
        tileDistance = 8.2;
        y = isTopRow ? 3.65 : 0.85;
        scale = [0.72, 0.72, 0.72];
      } else {
        // Preserve the original single-row desktop composition unchanged.
        angle = (fov / count) * i;
        tileDistance = distance;
        y = 3;
        scale = [1, 1, 1];
      }

      const z = -tileDistance * Math.sin(angle);
      const x = -tileDistance * Math.cos(angle);
      const rotY = Math.PI / 2 - angle;

      return (
        <ProjectTile
          key={i}
          project={project}
          index={i}
          position={[x, y, z]}
          scale={scale}
          rotation={[0, rotY, 0]}
          onClick={() => onClick(i)}
          isPhone={isPhone}
          focused={activeId === i}
          dimmed={isActive && isPhone && activeId !== null && activeId !== i}
          isActive={isActive}
        />
      );
    });
  }, [activeId, isActive, isPhone, onClick]);

  return (
    <group rotation={[0, isPhone ? 0 : -Math.PI / 12, 0]}>
      {tiles}
    </group>
  );
};

export default ProjectsCarousel;
